/*
 * Copyright (C) 2015 Spanning Cloud Apps LLC.  All rights reserved.
 */
import './uploadcsv.tpl.html';

angular
  .module('shared.uploadCSV', ['ngFileUpload'])
  /**
   * Controller for the shared/uploadcsv/uploadcsv.tpl.html template.
   */
  .controller('UploadCsvCtrl', function ($scope) {
    $scope.fileName = '';

    /**
     * Utility to upload a csv file.
     * @param {file} file - the file uploaded by user.
     * @param {file} errFiles - the file if errors occur during upload
     */
    $scope.upload = function (file, errFiles) {
      if (file && errFiles.length === 0) {
        $scope.uploadedCsv = true;
        $scope.uploadedFile = file;
        $scope.fileName = $scope.uploadedFile.name;
      }
    };

    /**
     * Utility to clear out the uploaded $scope.uploadedFile.
     */
    $scope.clearFile = function () {
      $scope.uploadedCsv = false;
      $scope.uploadedFile = undefined;
      $scope.fileName = '';
    };

    if ($scope.uploadedFile && $scope.uploadedFile.name) {
      $scope.fileName = $scope.uploadedFile.name;
    }
  })
  /**
   * The directive for the upload csv picker view. The storeName attribute should be
   * the name of the Store factory implementation to provide data to the picker.
   *
   * storeName - this should be a BasicBatchPickerStore.
   * batchIdToVerify - this is the batch to verify the uploaded file against.
   * uploadedCsv - Boolean flag if a csv has been uploaded or not.
   * uploadedFile - the uploaded file.
   */
  .directive('uploadcsv', function () {
    return {
      templateUrl: 'shared/uploadcsv/uploadcsv.tpl.html',
      scope: {
        uploadedCsv: '=',
        uploadedFile: '='
      },
      controller: 'UploadCsvCtrl'
    };
  });
